import { eDmLoaiLopTinChiActionsObj } from "../../action-types/category/IDmLoaiLopTinChiActions";
import { generateActions, generateActionForKey } from "../generateActions";
import { NotifyHelper } from "../../../helpers/toast";

export const dmLoaiLopTinChiActions = {
  ...generateActions(eDmLoaiLopTinChiActionsObj, "DM_LOAI_LOP_TIN_CHI"),
  ...generateActionForKey(
    eDmLoaiLopTinChiActionsObj,
    "DM_LOAI_LOP_TIN_CHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmLoaiLopTinChiActionsObj,
    "DM_LOAI_LOP_TIN_CHI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmLoaiLopTinChiActionsObj,
    "DM_LOAI_LOP_TIN_CHI",
    "SAVE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiLopTinChiActionsObj,
    "DM_LOAI_LOP_TIN_CHI",
    "DELETE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};

